const getters = {
    isPhone: state => state.app.isPhone,
}
export default getters